export default "__VITE_ASSET__DkB4rtTw__"